module.exports = __webpack_public_path__ + "static/media/gray-down-arrow.54048cde.svg";